import * as SheetPrimitive from '@radix-ui/react-dialog';

export const Sheet = SheetPrimitive.Root;
